var _Path, _Path2, _Path3, _Ellipse, _Ellipse2, _Path4, _Path5, _Path6, _Ellipse3, _Ellipse4, _Path7, _Path8, _Path9, _Ellipse5, _Ellipse6, _Path10, _Path11, _Path12, _Ellipse7, _Ellipse8, _Path13, _Path14, _Path15, _Ellipse9, _Ellipse10, _Path16, _Path17, _Path18, _Ellipse11, _Ellipse12, _Path19, _Path20, _Path21, _Ellipse13, _Ellipse14, _Path22, _Path23, _Path24, _Ellipse15, _Ellipse16, _Path25, _Path26, _Path27, _Ellipse17, _Ellipse18, _Path28, _G, _Path29, _G2, _Path30, _Path31, _Path32, _Ellipse19, _Ellipse20, _Path33, _Mask, _Path34, _Path35, _Path36, _Path37, _Path38, _Path39, _Path40, _Ellipse21, _Ellipse22, _Mask2, _Path41, _Path42, _Path43, _Ellipse23, _Path44, _Path45, _Path46, _Path47, _Path48, _Ellipse24, _Ellipse25, _Path49, _Path50, _Path51, _Ellipse26, _Ellipse27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Ellipse, Mask, G } from "react-native-svg";
function SvgAuthBiometric(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 350,
    height: 350,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220 283h-39v6h39c11.046 0 20-8.954 20-20v-36h-6v36c0 7.732-6.268 14-14 14z",
    fill: "#C1D4F7"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M181 283v-.25h-.25v.25h.25zm39 0v.25-.25zm-39 6h-.25v.25h.25V289zm39 0v.25-.25zm20-56h.25v-.25H240v.25zm-6 0v-.25h-.25v.25h.25zm-53 50.25h39v-.5h-39v.5zm.25 5.75v-6h-.5v6h.5zm38.75-.25h-39v.5h39v-.5zM239.75 269c0 10.908-8.842 19.75-19.75 19.75v.5c11.184 0 20.25-9.066 20.25-20.25h-.5zm0-36v36h.5v-36h-.5zm-5.75.25h6v-.5h-6v.5zm.25 35.75v-36h-.5v36h.5zM220 283.25c7.87 0 14.25-6.38 14.25-14.25h-.5c0 7.594-6.156 13.75-13.75 13.75v.5z",
    fill: "#2F2F2F"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209 287.251h11c10.079 0 18.25-8.171 18.25-18.25v-.8h-.5v.8c0 9.803-7.947 17.75-17.75 17.75h-11v.5zm-8-.5h-20v.5h20v-.5zm37.25-32.239h-.5v-21.511h.5v21.511z",
    fill: "#2F2F2F"
  })), _Ellipse || (_Ellipse = /*#__PURE__*/React.createElement(Ellipse, {
    rx: 2.5,
    ry: 3,
    transform: "matrix(0 1 1 0 237 232.5)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Ellipse2 || (_Ellipse2 = /*#__PURE__*/React.createElement(Ellipse, {
    rx: 1,
    ry: 3,
    transform: "matrix(-1 0 0 1 181 286)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220 166h-39v-6h39c11.046 0 20 8.954 20 20v36h-6v-36c0-7.732-6.268-14-14-14z",
    fill: "#C1D4F7"
  })), _Path5 || (_Path5 = /*#__PURE__*/React.createElement(Path, {
    d: "M181 166v.25h-.25V166h.25zm39 0v-.25.25zm-39-6h-.25v-.25h.25v.25zm39 0v-.25.25zm20 20h.25-.25zm0 36h.25v.25H240V216zm-6 0v.25h-.25V216h.25zm0-36h.25-.25zm-53-14.25h39v.5h-39v-.5zm.25-5.75v6h-.5v-6h.5zm38.75.25h-39v-.5h39v.5zM239.75 180c0-10.908-8.842-19.75-19.75-19.75v-.5c11.184 0 20.25 9.066 20.25 20.25h-.5zm0 36v-36h.5v36h-.5zm-5.75-.25h6v.5h-6v-.5zm.25-35.75v36h-.5v-36h.5zM220 165.75c7.87 0 14.25 6.38 14.25 14.25h-.5c0-7.594-6.156-13.75-13.75-13.75v-.5z",
    fill: "#2F2F2F"
  })), _Path6 || (_Path6 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209 163.751h11.001c8.974.001 16.249 7.276 16.249 16.25V181h-.5v-.999c0-8.698-7.051-15.749-15.749-15.75H209v-.5zm-8 .5l-15-.001v-.5l15 .001v.5zM236.25 194h-.5v16h.5v-16z",
    fill: "#2F2F2F"
  })), _Ellipse3 || (_Ellipse3 = /*#__PURE__*/React.createElement(Ellipse, {
    cx: 237,
    cy: 216.5,
    rx: 2.5,
    ry: 3,
    transform: "rotate(-90 237 216.5)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Ellipse4 || (_Ellipse4 = /*#__PURE__*/React.createElement(Ellipse, {
    cx: 181,
    cy: 163,
    rx: 1,
    ry: 3,
    transform: "rotate(180 181 163)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Path7 || (_Path7 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 184h39v6H34c-11.046 0-20-8.954-20-20v-36h6v36c0 7.732 6.268 14 14 14z",
    fill: "#FDFAA0"
  })), _Path8 || (_Path8 = /*#__PURE__*/React.createElement(Path, {
    d: "M73 184v-.25h.25v.25H73zm0 6h.25v.25H73V190zm-59-56h-.25v-.25H14v.25zm6 0v-.25h.25v.25H20zm53 50.25H34v-.5h39v.5zm-.25 5.75v-6h.5v6h-.5zM34 189.75h39v.5H34v-.5zM14.25 170c0 10.908 8.842 19.75 19.75 19.75v.5c-11.184 0-20.25-9.066-20.25-20.25h.5zm0-36v36h-.5v-36h.5zm5.75.25h-6v-.5h6v.5zM19.75 170v-36h.5v36h-.5zM34 184.25c-7.87 0-14.25-6.38-14.25-14.25h.5c0 7.594 6.156 13.75 13.75 13.75v.5z",
    fill: "#2F2F2F"
  })), _Path9 || (_Path9 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 188.251H34c-10.08 0-18.25-8.171-18.25-18.25v-.8h.5v.8c0 9.803 7.947 17.75 17.75 17.75h11v.5zm8-.5h20v.5H53v-.5zm-37.25-32.239h.5v-21.511h-.5v21.511z",
    fill: "#2F2F2F"
  })), _Ellipse5 || (_Ellipse5 = /*#__PURE__*/React.createElement(Ellipse, {
    cx: 17,
    cy: 133.5,
    rx: 2.5,
    ry: 3,
    transform: "rotate(90 17 133.5)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Ellipse6 || (_Ellipse6 = /*#__PURE__*/React.createElement(Ellipse, {
    cx: 73,
    cy: 187,
    rx: 1,
    ry: 3,
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Path10 || (_Path10 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124 67H85v-6h39c11.046 0 20 8.954 20 20v36h-6V81c0-7.732-6.268-14-14-14z",
    fill: "#FDFAA0"
  })), _Path11 || (_Path11 = /*#__PURE__*/React.createElement(Path, {
    d: "M85 67v.25h-.25V67H85zm0-6h-.25v-.25H85V61zm59 56h.25v.25H144V117zm-6 0v.25h-.25V117h.25zM85 66.75h39v.5H85v-.5zm.25-5.75v6h-.5v-6h.5zm38.75.25H85v-.5h39v.5zM143.75 81c0-10.908-8.842-19.75-19.75-19.75v-.5c11.184 0 20.25 9.066 20.25 20.25h-.5zm0 36V81h.5v36h-.5zm-5.75-.25h6v.5h-6v-.5zm.25-35.75v36h-.5V81h.5zM124 66.75c7.87 0 14.25 6.38 14.25 14.25h-.5c0-7.594-6.156-13.75-13.75-13.75v-.5z",
    fill: "#2F2F2F"
  })), _Path12 || (_Path12 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113 64.75l11.001.001c8.974 0 16.249 7.276 16.249 16.25V82h-.5v-.999c0-8.698-7.051-15.75-15.749-15.75H113v-.5zm-8 .5H90v-.5h15v.5zM140.25 95h-.5v16h.5V95z",
    fill: "#2F2F2F"
  })), _Ellipse7 || (_Ellipse7 = /*#__PURE__*/React.createElement(Ellipse, {
    cx: 141,
    cy: 117.5,
    rx: 2.5,
    ry: 3,
    transform: "rotate(-90 141 117.5)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Ellipse8 || (_Ellipse8 = /*#__PURE__*/React.createElement(Ellipse, {
    cx: 85,
    cy: 63.911,
    rx: 1,
    ry: 2.956,
    transform: "rotate(180 85 63.911)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Path13 || (_Path13 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315 67h-39v-6h39c11.046 0 20 8.954 20 20v36h-6V81c0-7.732-6.268-14-14-14z",
    fill: "#BAA7E2"
  })), _Path14 || (_Path14 = /*#__PURE__*/React.createElement(Path, {
    d: "M276 67v.25h-.25V67h.25zm0-6h-.25v-.25h.25V61zm59 56h.25v.25H335V117zm-6 0v.25h-.25V117h.25zm-53-50.25h39v.5h-39v-.5zm.25-5.75v6h-.5v-6h.5zm38.75.25h-39v-.5h39v.5zM334.75 81c0-10.908-8.842-19.75-19.75-19.75v-.5c11.184 0 20.25 9.066 20.25 20.25h-.5zm0 36V81h.5v36h-.5zm-5.75-.25h6v.5h-6v-.5zm.25-35.75v36h-.5V81h.5zM315 66.75c7.87 0 14.25 6.38 14.25 14.25h-.5c0-7.594-6.156-13.75-13.75-13.75v-.5z",
    fill: "#2F2F2F"
  })), _Path15 || (_Path15 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304 64.75l11.001.001c8.974 0 16.249 7.276 16.249 16.25V82h-.5v-.999c0-8.698-7.051-15.75-15.749-15.75H304v-.5zm-8 .5h-15v-.5h15v.5zM331.25 95h-.5v16h.5V95z",
    fill: "#2F2F2F"
  })), _Ellipse9 || (_Ellipse9 = /*#__PURE__*/React.createElement(Ellipse, {
    cx: 332,
    cy: 117.5,
    rx: 2.5,
    ry: 3,
    transform: "rotate(-90 332 117.5)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Ellipse10 || (_Ellipse10 = /*#__PURE__*/React.createElement(Ellipse, {
    cx: 276,
    cy: 63.911,
    rx: 1,
    ry: 2.956,
    transform: "rotate(180 276 63.911)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Path16 || (_Path16 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128 166h39v-6h-39c-11.046 0-20 8.954-20 20v36h6v-36c0-7.732 6.268-14 14-14z",
    fill: "#C1D4F7"
  })), _Path17 || (_Path17 = /*#__PURE__*/React.createElement(Path, {
    d: "M167 166v.25h.25V166H167zm0-6h.25v-.25H167v.25zm-59 56h-.25v.25h.25V216zm6 0v.25h.25V216H114zm53-50.25h-39v.5h39v-.5zm-.25-5.75v6h.5v-6h-.5zm-38.75.25h39v-.5h-39v.5zM108.25 180c0-10.908 8.842-19.75 19.75-19.75v-.5c-11.184 0-20.25 9.066-20.25 20.25h.5zm0 36v-36h-.5v36h.5zm5.75-.25h-6v.5h6v-.5zm-.25-35.75v36h.5v-36h-.5zM128 165.75c-7.87 0-14.25 6.38-14.25 14.25h.5c0-7.594 6.156-13.75 13.75-13.75v-.5z",
    fill: "#2F2F2F"
  })), _Path18 || (_Path18 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139 163.751h-11.001c-8.974.001-16.249 7.276-16.249 16.25V181h.5v-.999c0-8.698 7.051-15.749 15.749-15.75H139v-.5zm8 .5l15-.001v-.5l-15 .001v.5zM111.75 194h.5v16h-.5v-16z",
    fill: "#2F2F2F"
  })), _Ellipse11 || (_Ellipse11 = /*#__PURE__*/React.createElement(Ellipse, {
    rx: 2.5,
    ry: 3,
    transform: "matrix(0 -1 -1 0 111 216.5)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Ellipse12 || (_Ellipse12 = /*#__PURE__*/React.createElement(Ellipse, {
    rx: 1,
    ry: 3,
    transform: "matrix(1 0 0 -1 167 163)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Path19 || (_Path19 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128 283h39v6h-39c-11.046 0-20-8.954-20-20v-36h6v36c0 7.732 6.268 14 14 14z",
    fill: "#C1D4F7"
  })), _Path20 || (_Path20 = /*#__PURE__*/React.createElement(Path, {
    d: "M167 283v-.25h.25v.25H167zm0 6h.25v.25H167V289zm-59-56h-.25v-.25h.25v.25zm6 0v-.25h.25v.25H114zm53 50.25h-39v-.5h39v.5zm-.25 5.75v-6h.5v6h-.5zm-38.75-.25h39v.5h-39v-.5zM108.25 269c0 10.908 8.842 19.75 19.75 19.75v.5c-11.184 0-20.25-9.066-20.25-20.25h.5zm0-36v36h-.5v-36h.5zm5.75.25h-6v-.5h6v.5zm-.25 35.75v-36h.5v36h-.5zM128 283.25c-7.87 0-14.25-6.38-14.25-14.25h.5c0 7.594 6.156 13.75 13.75 13.75v.5z",
    fill: "#2F2F2F"
  })), _Path21 || (_Path21 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139 287.251h-11c-10.079 0-18.25-8.171-18.25-18.25v-.8h.5v.8c0 9.803 7.947 17.75 17.75 17.75h11v.5zm8-.5h20v.5h-20v-.5zm-37.25-32.239h.5v-21.511h-.5v21.511z",
    fill: "#2F2F2F"
  })), _Ellipse13 || (_Ellipse13 = /*#__PURE__*/React.createElement(Ellipse, {
    cx: 111,
    cy: 232.5,
    rx: 2.5,
    ry: 3,
    transform: "rotate(90 111 232.5)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Ellipse14 || (_Ellipse14 = /*#__PURE__*/React.createElement(Ellipse, {
    cx: 167,
    cy: 286.089,
    rx: 1,
    ry: 2.956,
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Path22 || (_Path22 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 67h39v-6H34c-11.046 0-20 8.954-20 20v36h6V81c0-7.732 6.268-14 14-14z",
    fill: "#FDFAA0"
  })), _Path23 || (_Path23 = /*#__PURE__*/React.createElement(Path, {
    d: "M73 67v.25h.25V67H73zm0-6h.25v-.25H73V61zm-59 56h-.25v.25H14V117zm6 0v.25h.25V117H20zm53-50.25H34v.5h39v-.5zM72.75 61v6h.5v-6h-.5zM34 61.25h39v-.5H34v.5zM14.25 81c0-10.908 8.842-19.75 19.75-19.75v-.5c-11.184 0-20.25 9.066-20.25 20.25h.5zm0 36V81h-.5v36h.5zm5.75-.25h-6v.5h6v-.5zM19.75 81v36h.5V81h-.5zM34 66.75c-7.87 0-14.25 6.38-14.25 14.25h.5c0-7.594 6.156-13.75 13.75-13.75v-.5z",
    fill: "#2F2F2F"
  })), _Path24 || (_Path24 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 64.75l-11 .001c-8.975 0-16.25 7.276-16.25 16.25V82h.5v-.999c0-8.698 7.051-15.75 15.75-15.75h11v-.5zm8 .5h15v-.5H53v.5zM17.75 95h.5v16h-.5V95z",
    fill: "#2F2F2F"
  })), _Ellipse15 || (_Ellipse15 = /*#__PURE__*/React.createElement(Ellipse, {
    rx: 2.5,
    ry: 3,
    transform: "matrix(0 -1 -1 0 17 117.5)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Ellipse16 || (_Ellipse16 = /*#__PURE__*/React.createElement(Ellipse, {
    rx: 1,
    ry: 3,
    transform: "matrix(1 0 0 -1 73 64)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Path25 || (_Path25 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224 67h39v-6h-39c-11.046 0-20 8.954-20 20v36h6V81c0-7.732 6.268-14 14-14z",
    fill: "#BAA7E2"
  })), _Path26 || (_Path26 = /*#__PURE__*/React.createElement(Path, {
    d: "M263 67v.25h.25V67H263zm0-6h.25v-.25H263V61zm-59 56h-.25v.25h.25V117zm6 0v.25h.25V117H210zm53-50.25h-39v.5h39v-.5zm-.25-5.75v6h.5v-6h-.5zm-38.75.25h39v-.5h-39v.5zM204.25 81c0-10.908 8.842-19.75 19.75-19.75v-.5c-11.184 0-20.25 9.066-20.25 20.25h.5zm0 36V81h-.5v36h.5zm5.75-.25h-6v.5h6v-.5zM209.75 81v36h.5V81h-.5zM224 66.75c-7.87 0-14.25 6.38-14.25 14.25h.5c0-7.594 6.156-13.75 13.75-13.75v-.5z",
    fill: "#2F2F2F"
  })), _Path27 || (_Path27 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235 64.75l-11.001.001c-8.974 0-16.249 7.276-16.249 16.25V82h.5v-.999c0-8.698 7.051-15.75 15.749-15.75H235v-.5zm8 .5h15v-.5h-15v.5zM207.75 95h.5v16h-.5V95z",
    fill: "#2F2F2F"
  })), _Ellipse17 || (_Ellipse17 = /*#__PURE__*/React.createElement(Ellipse, {
    rx: 2.5,
    ry: 3,
    transform: "matrix(0 -1 -1 0 207 117.5)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Ellipse18 || (_Ellipse18 = /*#__PURE__*/React.createElement(Ellipse, {
    rx: 1,
    ry: 2.956,
    transform: "matrix(1 0 0 -1 263 63.911)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement(Mask, {
    id: "auth-biometric_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 126,
    width: 67,
    height: 68
  }, _Path28 || (_Path28 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149 166.25V194H82v-14h45v-13.75h22zm0-6.5h-16v-33h16v33z",
    fill: "#C4C4C4"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#auth-biometric_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124 184H85v6h39c11.046 0 20-8.954 20-20v-36h-6v36c0 7.732-6.268 14-14 14z",
    fill: "#FDFAA0"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M85 184v-.25h-.25v.25H85zm0 6h-.25v.25H85V190zm59-56h.25v-.25H144v.25zm-6 0v-.25h-.25v.25h.25zm-53 50.25h39v-.5H85v.5zm.25 5.75v-6h-.5v6h.5zm38.75-.25H85v.5h39v-.5zM143.75 170c0 10.908-8.842 19.75-19.75 19.75v.5c11.184 0 20.25-9.066 20.25-20.25h-.5zm0-36v36h.5v-36h-.5zm-5.75.25h6v-.5h-6v.5zm.25 35.75v-36h-.5v36h.5zM124 184.25c7.87 0 14.25-6.38 14.25-14.25h-.5c0 7.594-6.156 13.75-13.75 13.75v.5z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113 188.251h11c10.079 0 18.25-8.171 18.25-18.25v-.8h-.5v.8c0 9.803-7.947 17.75-17.75 17.75h-11v.5zm-8-.5H85v.5h20v-.5zm37.25-32.239h-.5v-21.511h.5v21.511z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Ellipse, {
    rx: 2.5,
    ry: 3,
    transform: "matrix(0 1 1 0 141 133.5)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement(Ellipse, {
    rx: 1,
    ry: 3,
    transform: "matrix(-1 0 0 1 85 187)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement(Mask, {
    id: "auth-biometric_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 199,
    y: 126,
    width: 67,
    height: 68
  }, _Path29 || (_Path29 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199 166.25V194h67v-14h-45v-13.75h-22zm0-6.5h16v-33h-16v33z",
    fill: "#C4C4C4"
  }))), _G2 || (_G2 = /*#__PURE__*/React.createElement(G, {
    mask: "url(#auth-biometric_svg__b)"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224 184h39v6h-39c-11.046 0-20-8.954-20-20v-36h6v36c0 7.732 6.268 14 14 14z",
    fill: "#BAA7E2"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M263 184v-.25h.25v.25H263zm0 6h.25v.25H263V190zm-59-56h-.25v-.25h.25v.25zm6 0v-.25h.25v.25H210zm53 50.25h-39v-.5h39v.5zm-.25 5.75v-6h.5v6h-.5zm-38.75-.25h39v.5h-39v-.5zM204.25 170c0 10.908 8.842 19.75 19.75 19.75v.5c-11.184 0-20.25-9.066-20.25-20.25h.5zm0-36v36h-.5v-36h.5zm5.75.25h-6v-.5h6v.5zm-.25 35.75v-36h.5v36h-.5zM224 184.25c-7.87 0-14.25-6.38-14.25-14.25h.5c0 7.594 6.156 13.75 13.75 13.75v.5z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235 188.251h-11c-10.079 0-18.25-8.171-18.25-18.25v-.8h.5v.8c0 9.803 7.947 17.75 17.75 17.75h11v.5zm8-.5h20v.5h-20v-.5zm-37.25-32.239h.5v-21.511h-.5v21.511z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Ellipse, {
    cx: 207,
    cy: 133.5,
    rx: 2.5,
    ry: 3,
    transform: "rotate(90 207 133.5)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement(Ellipse, {
    cx: 263,
    cy: 187,
    rx: 1,
    ry: 3,
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  }))), _Path30 || (_Path30 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.326 121.405c17.755-29.782 59.889-32.428 81.23-5.101l1.512 1.936a8.81 8.81 0 01.236 10.528l-1.178 1.657A51.325 51.325 0 0178.043 152l-.087-5.999a45.324 45.324 0 0036.28-19.053l1.179-1.657a2.81 2.81 0 00-.076-3.358l-1.512-1.936c-18.745-24.003-55.752-21.679-71.347 4.48l-5.154-3.072z",
    fill: "#8ED7AF"
  })), _Path31 || (_Path31 = /*#__PURE__*/React.createElement(Path, {
    d: "M118.556 116.304l-.197.154.197-.154zm-81.23 5.101l-.215-.128-.128.215.215.128.128-.215zm82.742-3.165l.197-.154-.197.154zm.236 10.528l.204.145-.204-.145zm-1.178 1.657l-.204-.145.204.145zM78.043 152l-.25.004.004.25.25-.004-.004-.25zm-.087-5.999l-.003-.25-.25.004.003.249.25-.003zm36.28-19.053l-.204-.145.204.145zm1.179-1.657l.203.145-.203-.145zm-.076-3.358l-.197.154.197-.154zm-1.512-1.936l-.197.154.197-.154zm-71.347 4.48l-.128.215.215.128.128-.215-.215-.128zm76.273-8.327c-21.45-27.466-63.797-24.806-81.642 5.127l.43.256c17.665-29.632 59.585-32.264 80.818-5.075l.394-.308zm1.512 1.936l-1.512-1.936-.394.308 1.512 1.936.394-.308zm.243 10.827a9.061 9.061 0 00-.243-10.827l-.394.308a8.56 8.56 0 01.23 10.229l.407.29zm-1.178 1.657l1.178-1.657-.407-.29-1.179 1.657.408.29zm-41.283 21.68a51.574 51.574 0 0041.283-21.68l-.408-.29a51.071 51.071 0 01-40.882 21.47l.007.5zm-.34-6.246l.086 6 .5-.007-.087-6-.5.007zm36.325-19.201a45.07 45.07 0 01-36.08 18.948l.008.5a45.576 45.576 0 0036.48-19.158l-.408-.29zm1.179-1.657l-1.179 1.657.408.29 1.178-1.657-.407-.29zm-.069-3.059a2.56 2.56 0 01.069 3.059l.407.29a3.06 3.06 0 00-.082-3.657l-.394.308zm-1.512-1.936l1.512 1.936.394-.308-1.512-1.936-.394.308zm-70.935 4.454c15.505-26.008 52.298-28.318 70.935-4.454l.394-.308c-18.853-24.141-56.074-21.804-71.759 4.506l.43.256zm-5.497-2.985l5.154 3.072.256-.429-5.154-3.073-.256.43z",
    fill: "#2F2F2F"
  })), _Path32 || (_Path32 = /*#__PURE__*/React.createElement(Path, {
    d: "M91.312 103.384l-.517-.136c-18.656-4.91-38.343 2.832-48.656 19.135v0M105.282 109.53l.621.478a61.366 61.366 0 0111.673 11.816v0M119.811 126.294l-1.184 1.842a48.334 48.334 0 01-39.608 22.186v0",
    stroke: "#2F2F2F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _Ellipse19 || (_Ellipse19 = /*#__PURE__*/React.createElement(Ellipse, {
    rx: 2.519,
    ry: 3.028,
    transform: "scale(1 -1) rotate(58.094 130.96 -26.104)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Ellipse20 || (_Ellipse20 = /*#__PURE__*/React.createElement(Ellipse, {
    rx: 2,
    ry: 3,
    transform: "matrix(1 0 0 -1 78 149)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Path33 || (_Path33 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.035 125.672c-1.972 5.459-7.862 8.693-13.002 7.489-5.14-1.204-7.956-6.476-5.985-11.935 1.972-5.458 7.863-8.694 13.002-7.489 5.14 1.205 7.957 6.477 5.985 11.935zm-9.718-5.824c-.14 1.357-1.405 2.472-2.772 2.54-1.366.067-2.414-.934-2.275-2.291.14-1.358 1.406-2.474 2.773-2.541 1.366-.067 2.414.934 2.274 2.292zm1.87 8.743c.29.602 1.34.52 2.371-.238 1.031-.759 1.588-1.86 1.297-2.461-.29-.602-1.34-.521-2.37.238-1.032.759-1.588 1.86-1.298 2.461z",
    fill: "#12367C"
  })), _Mask || (_Mask = /*#__PURE__*/React.createElement(Mask, {
    id: "auth-biometric_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.805 115.238c-4.248-1.004-9.466 1.739-11.218 6.628-1.686 4.704.72 8.839 4.714 9.782 4.25 1.003 9.466-1.739 11.218-6.628 1.686-4.703-.72-8.839-4.714-9.782zm-16.864 4.689c2.73-7.617 10.903-12.286 18.337-10.529 7.688 1.817 11.684 9.759 8.886 17.561-2.73 7.617-10.901 12.284-18.335 10.529-7.689-1.816-11.684-9.758-8.888-17.561z"
  }))), _Path34 || (_Path34 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.805 115.238c-4.248-1.004-9.466 1.739-11.218 6.628-1.686 4.704.72 8.839 4.714 9.782 4.25 1.003 9.466-1.739 11.218-6.628 1.686-4.703-.72-8.839-4.714-9.782zm-16.864 4.689c2.73-7.617 10.903-12.286 18.337-10.529 7.688 1.817 11.684 9.759 8.886 17.561-2.73 7.617-10.901 12.284-18.335 10.529-7.689-1.816-11.684-9.758-8.888-17.561z",
    fill: "#E9E2F9"
  })), _Path35 || (_Path35 = /*#__PURE__*/React.createElement(Path, {
    d: "M70.587 121.866l.47.169-.47-.169zm11.218-6.628l-.115.486.115-.486zm-6.504 16.41l-.115.487.115-.487zm11.218-6.628l-.47-.17v.002l.47.168zm0 0l.47.17.001-.001-.47-.169zm-3.241-15.622l.115-.487-.115.487zm-18.337 10.529l.471.169-.47-.169zm27.224 7.032l-.471-.168.47.168zm-18.336 10.529l.115-.487-.115.487zm-2.771-15.453c1.672-4.668 6.65-7.252 10.632-6.311l.23-.973c-4.514-1.067-9.972 1.835-11.804 6.946l.942.338zm4.358 9.127c-3.68-.869-5.952-4.681-4.358-9.127l-.942-.338c-1.778 4.962.763 9.421 5.07 10.438l.23-.973zm10.633-6.31c-1.673 4.666-6.65 7.25-10.633 6.31l-.23.973c4.515 1.066 9.972-1.836 11.804-6.946l-.941-.337zm0-.002l.94.341v-.001l-.94-.34zm-4.36-9.126c3.681.87 5.953 4.682 4.36 9.127l.941.338c1.778-4.961-.762-9.42-5.07-10.438l-.23.973zm1.704-6.813c-7.702-1.82-16.114 3.011-18.922 10.848l.941.337c2.651-7.398 10.584-11.905 17.751-10.211l.23-.974zm9.242 18.217c2.888-8.055-1.235-16.324-9.242-18.217l-.23.974c7.37 1.741 11.237 9.356 8.53 16.906l.942.337zm-18.92 10.847c7.7 1.818 16.111-3.01 18.92-10.847l-.941-.337c-2.651 7.397-10.584 11.902-17.75 10.21l-.23.974zm-9.244-18.216c-2.887 8.055 1.236 16.325 9.243 18.216l.23-.974c-7.37-1.74-11.238-9.355-8.532-16.905l-.941-.337z",
    fill: "#2F2F2F",
    mask: "url(#auth-biometric_svg__c)"
  })), _Path36 || (_Path36 = /*#__PURE__*/React.createElement(Path, {
    d: "M91.313 124.059l-.032.162a15.185 15.185 0 01-13.38 12.132v0M73.99 112.324v0a13.588 13.588 0 00-6.167 5.285l-.538.862",
    stroke: "#2F2F2F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _Path37 || (_Path37 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.484 114.242c0-15.598-12.645-28.242-28.243-28.242-15.597 0-28.242 12.644-28.242 28.242v27.649c0 10.859 8.803 19.662 19.662 19.662 10.859 0 19.662-8.803 19.662-19.662v-27.649c0-6.12-4.961-11.081-11.081-11.081-6.12 0-11.081 4.961-11.081 11.081v27.945a2.5 2.5 0 105 0v-27.945a6.082 6.082 0 0112.162 0v27.649c0 8.098-6.565 14.662-14.662 14.662-8.098 0-14.662-6.564-14.662-14.662v-27.649c0-12.836 10.406-23.242 23.242-23.242 12.837 0 23.243 10.406 23.243 23.242v29.173a28.772 28.772 0 01-5.263 16.586l4.085 2.883a33.764 33.764 0 006.178-19.469v-29.173z",
    fill: "#FDFAA0"
  })), _Path38 || (_Path38 = /*#__PURE__*/React.createElement(Path, {
    d: "M288.221 160.001l-.144.204a.25.25 0 01-.06-.348l.204.144zm4.085 2.883l.204.144a.25.25 0 01-.348.06l.144-.204zM270.241 85.75c15.736 0 28.493 12.756 28.493 28.492h-.5c0-15.46-12.533-27.992-27.993-27.992v-.5zm-28.492 28.492c0-15.736 12.757-28.492 28.492-28.492v.5c-15.459 0-27.992 12.532-27.992 27.992h-.5zm0 27.649v-27.649h.5v27.649h-.5zm19.912 19.912c-10.997 0-19.912-8.915-19.912-19.912h.5c0 10.721 8.691 19.412 19.412 19.412v.5zm19.912-19.912c0 10.997-8.915 19.912-19.912 19.912v-.5c10.721 0 19.412-8.691 19.412-19.412h.5zm0-27.649v27.649h-.5v-27.649h.5zm-11.331-11.331c6.258 0 11.331 5.073 11.331 11.331h-.5c0-5.981-4.849-10.831-10.831-10.831v-.5zm-11.331 11.331c0-6.258 5.073-11.331 11.331-11.331v.5c-5.982 0-10.831 4.85-10.831 10.831h-.5zm0 27.945v-27.945h.5v27.945h-.5zm2.75 2.75a2.75 2.75 0 01-2.75-2.75h.5a2.25 2.25 0 002.25 2.25v.5zm2.75-2.75a2.75 2.75 0 01-2.75 2.75v-.5a2.25 2.25 0 002.25-2.25h.5zm0-27.945v27.945h-.5v-27.945h.5zm5.831-5.831a5.831 5.831 0 00-5.831 5.831h-.5a6.332 6.332 0 016.331-6.331v.5zm5.831 5.831a5.831 5.831 0 00-5.831-5.831v-.5a6.332 6.332 0 016.331 6.331h-.5zm0 27.649v-27.649h.5v27.649h-.5zm-14.412 14.412c7.959 0 14.412-6.452 14.412-14.412h.5c0 8.236-6.677 14.912-14.912 14.912v-.5zm-14.412-14.412c0 7.96 6.452 14.412 14.412 14.412v.5c-8.236 0-14.912-6.676-14.912-14.912h.5zm0-27.649v27.649h-.5v-27.649h.5zm22.992-22.992c-12.698 0-22.992 10.294-22.992 22.992h-.5c0-12.974 10.518-23.492 23.492-23.492v.5zm22.993 22.992c0-12.698-10.294-22.992-22.993-22.992v-.5c12.975 0 23.493 10.518 23.493 23.492h-.5zm0 29.173v-29.173h.5v29.173h-.5zm-5.217 16.442a28.523 28.523 0 005.217-16.442h.5a29.019 29.019 0 01-5.309 16.73l-.408-.288zm4.145 3.231l-4.085-2.883.288-.408 4.085 2.883-.288.408zm6.572-19.673a34.013 34.013 0 01-6.224 19.613l-.408-.288a33.517 33.517 0 006.132-19.325h.5zm0-29.173v29.173h-.5v-29.173h.5z",
    fill: "#2F2F2F"
  })), _Path39 || (_Path39 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.904 114.231c0-10.86-8.812-19.659-19.672-19.644-10.838.015-19.617 8.806-19.617 19.644v27.66c0 6.111 4.954 11.065 11.065 11.065s11.064-4.954 11.064-11.065v-27.703a2.5 2.5 0 00-5 0v27.703a6.064 6.064 0 11-12.129 0v-27.66c0-8.08 6.544-14.633 14.624-14.644 8.096-.011 14.665 6.549 14.665 14.644v28.676a20.314 20.314 0 01-5.943 14.358l3.538 3.534a25.315 25.315 0 007.405-17.892v-28.676z",
    fill: "#FDFAA0"
  })), _Path40 || (_Path40 = /*#__PURE__*/React.createElement(Path, {
    d: "M270.232 94.587v-.25.25zm.007 5l.001.25-.001-.25zm8.722 57.678l-.176.177a.249.249 0 010-.353l.176.176zm3.538 3.534l.177.177a.252.252 0 01-.354 0l.177-.177zm-12.267-66.462c10.998-.015 19.922 8.896 19.922 19.894h-.5c0-10.721-8.699-19.409-19.421-19.394l-.001-.5zm-19.867 19.894c0-10.976 8.89-19.879 19.867-19.894l.001.5c-10.701.015-19.368 8.694-19.368 19.394h-.5zm0 27.66v-27.66h.5v27.66h-.5zm11.315 11.315c-6.249 0-11.315-5.066-11.315-11.315h.5c0 5.973 4.842 10.815 10.815 10.815v.5zm11.314-11.315c0 6.249-5.065 11.315-11.314 11.315v-.5c5.972 0 10.814-4.842 10.814-10.815h.5zm0-27.703v27.703h-.5v-27.703h.5zm-2.75-2.75a2.75 2.75 0 012.75 2.75h-.5a2.25 2.25 0 00-2.25-2.25v-.5zm-2.75 2.75a2.75 2.75 0 012.75-2.75v.5a2.25 2.25 0 00-2.25 2.25h-.5zm0 27.703v-27.703h.5v27.703h-.5zm-5.814 5.815a5.814 5.814 0 005.814-5.815h.5a6.314 6.314 0 01-6.314 6.315v-.5zm-5.815-5.815a5.814 5.814 0 005.815 5.815v.5a6.315 6.315 0 01-6.315-6.315h.5zm0-27.66v27.66h-.5v-27.66h.5zm14.375-14.394c-7.942.011-14.375 6.452-14.375 14.394h-.5c0-8.217 6.656-14.883 14.874-14.894l.001.5zm14.414 14.394c0-7.957-6.457-14.405-14.414-14.394l-.001-.5c8.234-.011 14.915 6.66 14.915 14.894h-.5zm0 28.676v-28.676h.5v28.676h-.5zm-5.869 14.182a20.07 20.07 0 005.869-14.182h.5a20.567 20.567 0 01-6.016 14.535l-.353-.353zm3.537 3.887l-3.537-3.534.353-.354 3.538 3.534-.354.354zm7.832-18.069a25.57 25.57 0 01-7.478 18.069l-.354-.354a25.067 25.067 0 007.332-17.715h.5zm0-28.676v28.676h-.5v-28.676h.5z",
    fill: "#2F2F2F"
  })), _Ellipse21 || (_Ellipse21 = /*#__PURE__*/React.createElement(Ellipse, {
    rx: 2.093,
    ry: 2.498,
    transform: "scale(1 -1) rotate(45 332.347 259.335)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Ellipse22 || (_Ellipse22 = /*#__PURE__*/React.createElement(Ellipse, {
    rx: 1.907,
    ry: 2.492,
    transform: "scale(1 -1) rotate(53.155 306.57 209.261)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Mask2 || (_Mask2 = /*#__PURE__*/React.createElement(Mask, {
    id: "auth-biometric_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.934 191.679c-17.083-4.037-37.071 6.858-43.768 25.545-4.185 11.678-1.914 22.884 4.434 30.516l-5.414 4.528c-7.99-9.606-10.584-23.416-5.606-37.306 7.837-21.87 31.272-35.011 52.073-30.096 21.097 4.986 32.404 26.79 24.486 48.874-7.837 21.868-31.27 35.005-52.07 30.094-4.88-1.153-9.269-3.221-13.022-6.014-1.538-1.145-1.836-3.335-.665-4.892 1.171-1.558 3.367-1.892 4.905-.748 2.998 2.231 6.527 3.903 10.499 4.841 17.085 4.034 37.07-6.858 43.767-25.543 6.621-18.469-2.832-35.832-19.619-39.799z"
  }))), _Path41 || (_Path41 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.934 191.679c-17.083-4.037-37.071 6.858-43.768 25.545-4.185 11.678-1.914 22.884 4.434 30.516l-5.414 4.528c-7.99-9.606-10.584-23.416-5.606-37.306 7.837-21.87 31.272-35.011 52.073-30.096 21.097 4.986 32.404 26.79 24.486 48.874-7.837 21.868-31.27 35.005-52.07 30.094-4.88-1.153-9.269-3.221-13.022-6.014-1.538-1.145-1.836-3.335-.665-4.892 1.171-1.558 3.367-1.892 4.905-.748 2.998 2.231 6.527 3.903 10.499 4.841 17.085 4.034 37.07-6.858 43.767-25.543 6.621-18.469-2.832-35.832-19.619-39.799z",
    fill: "#BAA7E2"
  })), _Path42 || (_Path42 = /*#__PURE__*/React.createElement(Path, {
    d: "M143.166 217.224l.471.169-.471-.169zm43.768-25.545l.115-.486-.115.486zM147.6 247.74l.321.384.382-.32-.318-.384-.385.32zm-5.414 4.528l-.384.32.321.386.384-.322-.321-.384zm-5.606-37.306l.47.169-.47-.169zm52.073-30.096l.115-.486-.115.486zm24.486 48.874l-.47-.169.47.169zm-52.07 30.094l.115-.487-.115.487zm-13.022-6.014l.298-.401-.298.401zm-.665-4.892l.399.3-.399-.3zm4.905-.748l-.298.401.298-.401zm10.499 4.841l-.115.486.115-.486zm43.767-25.543l-.469-.174-.002.005.471.169zm0 0l.469.174.002-.006-.471-.168zm-62.916-14.085c6.617-18.467 26.365-29.202 43.182-25.227l.23-.973c-17.35-4.101-37.578 6.954-44.354 25.862l.942.338zm4.348 30.027c-6.228-7.487-8.478-18.504-4.348-30.027l-.942-.338c-4.241 11.834-1.949 23.227 4.521 31.005l.769-.64zm-5.478 5.232l5.414-4.528-.642-.767-5.413 4.528.641.767zm-6.398-37.859c-5.033 14.045-2.418 28.043 5.693 37.795l.769-.639c-7.87-9.462-10.443-23.084-5.521-36.818l-.941-.338zm52.659-30.413c-21.068-4.979-44.743 8.323-52.659 30.413l.941.338c7.759-21.65 30.954-34.631 51.488-29.778l.23-.973zm24.842 49.529c8.008-22.338-3.428-44.468-24.842-49.529l-.23.973c20.779 4.911 31.957 26.388 24.131 48.218l.941.338zm-52.656 30.411c21.067 4.975 44.739-8.323 52.656-30.411l-.941-.338c-7.759 21.648-30.952 34.624-51.485 29.776l-.23.973zm-13.206-6.099c3.809 2.834 8.26 4.931 13.206 6.099l.23-.973c-4.815-1.137-9.141-3.177-12.839-5.928l-.597.802zm-.766-5.594c-1.333 1.773-1 4.279.766 5.594l.597-.802c-1.31-.975-1.573-2.849-.564-4.191l-.799-.601zm5.604-.848c-1.765-1.313-4.272-.923-5.604.848l.799.601c1.01-1.343 2.896-1.622 4.208-.647l.597-.802zm10.315 4.755c-3.907-.923-7.373-2.566-10.315-4.755l-.597.802c3.053 2.272 6.644 3.973 10.682 4.926l.23-.973zm43.181-25.225c-6.617 18.464-26.363 29.196-43.181 25.225l-.23.973c17.351 4.097 37.577-6.955 44.353-25.86l-.942-.338zm.002-.005l.938.348-.938-.348zm-19.265-39.138c16.471 3.892 25.793 20.93 19.264 39.143l.941.337c6.712-18.723-2.872-36.411-19.975-40.453l-.23.973z",
    fill: "#2F2F2F",
    mask: "url(#auth-biometric_svg__d)"
  })), _Path43 || (_Path43 = /*#__PURE__*/React.createElement(Path, {
    d: "M172.827 263.33l1.62-.243a48.068 48.068 0 0017.412-6.206v0a48.066 48.066 0 0015.458-14.671l.498-.748M213.83 214.126v0a39.69 39.69 0 01-3.159 22.038l-.668 1.47",
    stroke: "#2F2F2F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _Ellipse23 || (_Ellipse23 = /*#__PURE__*/React.createElement(Ellipse, {
    cx: 144.671,
    cy: 249.738,
    rx: 2.723,
    ry: 3.304,
    transform: "rotate(48.704 144.671 249.738)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Path44 || (_Path44 = /*#__PURE__*/React.createElement(Path, {
    d: "M178.294 188.431l-1.692.169a41.918 41.918 0 00-17.229 5.667v0a41.91 41.91 0 00-14.993 15.245l-1.075 1.881M142.758 244.195l-.439-.877a32.633 32.633 0 01-2.295-23.178v0",
    stroke: "#2F2F2F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _Path45 || (_Path45 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.279 223.934c-.297.364-.814.423-1.238.221a7.898 7.898 0 00-1.066-.415c-1.718-.528-3.518-.429-5.238.196-.506.184-1.093-.004-1.271-.512-.786-2.24-.66-5.322.587-8.285 1.946-4.624 5.766-6.915 8.484-5.364 1.865 1.064 2.82 3.712 2.607 6.763a3.297 3.297 0 013.203-2.515h10.357a3.296 3.296 0 110 6.591h-10.357a3.297 3.297 0 01-3.295-3.203 13.87 13.87 0 01-.958 3.453 12.631 12.631 0 01-1.815 3.07z",
    fill: "#13367C"
  })), _Path46 || (_Path46 = /*#__PURE__*/React.createElement(Path, {
    d: "M170.041 224.155l-.107.226.107-.226zm1.238-.221l-.194-.158.194.158zm-2.304-.194l-.073.239.073-.239zm-5.238.196l.085.235-.085-.235zm-1.271-.512l.236-.083-.236.083zm.587-8.285l-.23-.097.23.097zm8.484-5.364l-.124.217.124-.217zm2.607 6.763l-.249-.017.492.076-.243-.059zm-.092.873l.25-.007-.497-.028.247.035zm-.958 3.453l-.231-.097.231.097zm-3.16 3.517c.502.239 1.153.184 1.538-.289l-.387-.316c-.208.255-.592.318-.936.154l-.215.451zm-1.032-.402c.355.109.699.244 1.032.402l.215-.451a7.96 7.96 0 00-1.1-.429l-.147.478zm-5.08.192c1.675-.609 3.419-.702 5.08-.192l.147-.478c-1.776-.546-3.632-.441-5.398.2l.171.47zm-1.592-.665c.236.675.993.882 1.592.665l-.171-.47c-.413.15-.83-.018-.949-.36l-.472.165zm.593-8.464c-1.267 3.009-1.403 6.156-.593 8.464l.472-.165c-.762-2.171-.646-5.188.581-8.105l-.46-.194zm8.838-5.484c-1.461-.834-3.196-.619-4.787.371-1.591.99-3.062 2.764-4.051 5.113l.46.194c.958-2.274 2.369-3.958 3.855-4.882 1.484-.924 3.018-1.079 4.275-.362l.248-.434zm2.732 6.997c.216-3.09-.744-5.863-2.732-6.997l-.248.434c1.742.994 2.692 3.518 2.482 6.529l.498.034zm-.006.042a3.046 3.046 0 012.96-2.324v-.5a3.546 3.546 0 00-3.446 2.706l.486.118zm2.96-2.324h10.357v-.5h-10.357v.5zm10.357 0a3.045 3.045 0 013.046 3.045h.5a3.545 3.545 0 00-3.546-3.545v.5zm3.046 3.045a3.046 3.046 0 01-3.046 3.046v.5a3.545 3.545 0 003.546-3.546h-.5zm-3.046 3.046h-10.357v.5h10.357v-.5zm-10.357 0a3.046 3.046 0 01-3.045-2.96l-.5.014a3.546 3.546 0 003.545 3.446v-.5zm-4.023.597c.494-1.171.815-2.362.976-3.515l-.495-.07a13.615 13.615 0 01-.942 3.391l.461.194zm-1.852 3.131a12.828 12.828 0 001.852-3.131l-.461-.194a12.352 12.352 0 01-1.778 3.009l.387.316z",
    fill: "#2F2F2F"
  })), _Path47 || (_Path47 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.039 237.627a20.822 20.822 0 005.898 2.372c10.062 2.376 21.148-2.513 27.196-11.52l-4.092-2.8c-4.928 7.406-13.986 11.317-21.878 9.453a15.8 15.8 0 01-4.528-1.831l-2.596 4.326z",
    fill: "#FFB8BD"
  })), _Path48 || (_Path48 = /*#__PURE__*/React.createElement(Path, {
    d: "M165.937 239.999l.057-.244-.057.244zm-5.898-2.372l-.214-.129-.129.215.215.129.128-.215zm33.094-9.148l.207.14.138-.206-.204-.14-.141.206zm-4.092-2.8l.141-.207-.209-.143-.141.211.209.139zm-21.878 9.453l.058-.243-.058.243zm-4.528-1.831l.129-.215-.215-.128-.129.214.215.129zm3.359 6.454a20.563 20.563 0 01-5.827-2.343l-.256.43a21.084 21.084 0 005.968 2.4l.115-.487zm26.931-11.415c-5.996 8.931-16.982 13.765-26.931 11.415l-.115.487c10.176 2.403 21.363-2.541 27.461-11.623l-.415-.279zm.349-.067l-4.092-2.801-.283.413 4.093 2.801.282-.413zm-26.168 7.103c8.005 1.89 17.164-2.077 22.143-9.559l-.417-.277c-4.877 7.33-13.834 11.185-21.611 9.349l-.115.487zm-4.6-1.861a16.095 16.095 0 004.6 1.861l.115-.487a15.56 15.56 0 01-4.457-1.803l-.258.429zm-.086-.343l-2.595 4.326.428.258 2.596-4.327-.429-.257z",
    fill: "#2F2F2F"
  })), _Ellipse24 || (_Ellipse24 = /*#__PURE__*/React.createElement(Ellipse, {
    cx: 161.295,
    cy: 235.437,
    rx: 1.7,
    ry: 2.529,
    transform: "rotate(30.575 161.295 235.437)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Ellipse25 || (_Ellipse25 = /*#__PURE__*/React.createElement(Ellipse, {
    cx: 191.165,
    cy: 226.946,
    rx: 1.915,
    ry: 2.478,
    transform: "rotate(120 191.165 226.946)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Path49 || (_Path49 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315 184h-39v6h39c11.046 0 20-8.954 20-20v-36h-6v36c0 7.732-6.268 14-14 14z",
    fill: "#BAA7E2"
  })), _Path50 || (_Path50 = /*#__PURE__*/React.createElement(Path, {
    d: "M276 184v-.25h-.25v.25h.25zm0 6h-.25v.25h.25V190zm59-56h.25v-.25H335v.25zm-6 0v-.25h-.25v.25h.25zm-53 50.25h39v-.5h-39v.5zm.25 5.75v-6h-.5v6h.5zm38.75-.25h-39v.5h39v-.5zM334.75 170c0 10.908-8.842 19.75-19.75 19.75v.5c11.184 0 20.25-9.066 20.25-20.25h-.5zm0-36v36h.5v-36h-.5zm-5.75.25h6v-.5h-6v.5zm.25 35.75v-36h-.5v36h.5zM315 184.25c7.87 0 14.25-6.38 14.25-14.25h-.5c0 7.594-6.156 13.75-13.75 13.75v.5z",
    fill: "#2F2F2F"
  })), _Path51 || (_Path51 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304 188.251h11c10.079 0 18.25-8.171 18.25-18.25v-.8h-.5v.8c0 9.803-7.947 17.75-17.75 17.75h-11v.5zm-8-.5h-20v.5h20v-.5zm37.25-32.239h-.5v-21.511h.5v21.511z",
    fill: "#2F2F2F"
  })), _Ellipse26 || (_Ellipse26 = /*#__PURE__*/React.createElement(Ellipse, {
    rx: 2.5,
    ry: 3,
    transform: "matrix(0 1 1 0 332 133.5)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })), _Ellipse27 || (_Ellipse27 = /*#__PURE__*/React.createElement(Ellipse, {
    rx: 1,
    ry: 3,
    transform: "matrix(-1 0 0 1 276 187)",
    fill: "#fff",
    stroke: "#2F2F2F",
    strokeWidth: 0.5
  })));
}
export default SvgAuthBiometric;